import { resolveBooleanEnvVar, resolveNumberEnvVar, resolveStringEnvVar } from './env.utils';

const runtimeEnv = {
    VITE_NODE_ENV: resolveStringEnvVar('VITE_NODE_ENV', process.env.VITE_NODE_ENV ?? '', ''),
    VITE_APP_HOST: resolveStringEnvVar('VITE_APP_HOST', process.env.VITE_APP_HOST ?? '', ''),
    VITE_REST_API_HOST: resolveStringEnvVar('VITE_REST_API_HOST', process.env.VITE_REST_API_HOST ?? '', ''),
    VITE_GLOBAL_API_HOST: resolveStringEnvVar('VITE_GLOBAL_API_HOST', process.env.VITE_GLOBAL_API_HOST ?? '', ''),
    VITE_AOM_API_HOST: resolveStringEnvVar('VITE_AOM_API_HOST', process.env.VITE_AOM_API_HOST ?? '', ''),
    VITE_ADM_API_HOST: resolveStringEnvVar('VITE_ADM_API_HOST', process.env.VITE_ADM_API_HOST ?? '', ''),
    VITE_AMM_API_HOST: resolveStringEnvVar('VITE_AMM_API_HOST', process.env.VITE_AMM_API_HOST ?? '', ''),
    VITE_API_ENABLE_OPERATORS_QUERY_SEARCH: resolveStringEnvVar(
        'VITE_API_ENABLE_OPERATORS_QUERY_SEARCH',
        process.env.VITE_API_ENABLE_OPERATORS_QUERY_SEARCH ?? '',
        ''
    ),
    VITE_AUTH_AUTHORITY: resolveStringEnvVar('VITE_AUTH_AUTHORITY', process.env.VITE_AUTH_AUTHORITY ?? '', ''),
    VITE_AUTH_CLIENTID: resolveStringEnvVar('VITE_AUTH_CLIENTID', process.env.VITE_AUTH_CLIENTID ?? '', ''),
    VITE_AUTH_RESPONSE_TYPE: resolveStringEnvVar(
        'VITE_AUTH_RESPONSE_TYPE',
        process.env.VITE_AUTH_RESPONSE_TYPE ?? '',
        ''
    ),
    VITE_AUTH_SCOPE: resolveStringEnvVar('VITE_AUTH_SCOPE', process.env.VITE_AUTH_SCOPE ?? '', ''),
    VITE_AUTH_POST_LOGOUT_REDIRECT_URL: resolveStringEnvVar(
        'VITE_AUTH_POST_LOGOUT_REDIRECT_URL',
        process.env.VITE_AUTH_POST_LOGOUT_REDIRECT_URL ?? '',
        ''
    ),

    VITE_TRANSLATIONS_API: resolveStringEnvVar('VITE_TRANSLATIONS_API', process.env.VITE_TRANSLATIONS_API ?? '', ''),
    VITE_ONE_TRUST_ID: resolveStringEnvVar('VITE_ONE_TRUST_ID', process.env.VITE_ONE_TRUST_ID ?? '', ''),
    VITE_OTS_LICENSE_FILE_NAME: resolveStringEnvVar(
        'VITE_OTS_LICENSE_FILE_NAME',
        process.env.VITE_OTS_LICENSE_FILE_NAME ?? '',
        ''
    ),
    VITE_ALLOW_DEV_OPTIONS: resolveBooleanEnvVar(
        'VITE_ALLOW_DEV_OPTIONS',
        process.env.VITE_ALLOW_DEV_OPTIONS ?? 'true',
        true
    ),
    VITE_INACTIVITY_TIMEOUT: resolveNumberEnvVar(
        'VITE_INACTIVITY_TIMEOUT',
        process.env.VITE_INACTIVITY_TIMEOUT ?? '1000',
        3000
    ),
    VITE_API_TIMEOUT: resolveNumberEnvVar('VITE_API_TIMEOUT', process.env.VITE_API_TIMEOUT ?? '1000', 3000),
    VITE_USER_ASSISTANCE_URL: resolveStringEnvVar(
        'VITE_USER_ASSISTANCE_URL',
        process.env.VITE_USER_ASSISTANCE_URL ?? '',
        ''
    ),
    VITE_USER_ASSISTANCE_CHECK_RESOURCE: resolveStringEnvVar(
        'VITE_USER_ASSISTANCE_CHECK_RESOURCE',
        process.env.VITE_USER_ASSISTANCE_CHECK_RESOURCE ?? '',
        ''
    ),
    VITE_USER_ASSISTANCE_PRODUCT: resolveStringEnvVar(
        'VITE_USER_ASSISTANCE_PRODUCT',
        process.env.VITE_USER_ASSISTANCE_PRODUCT ?? '',
        ''
    ),
    VITE_USER_ASSISTANCE_TOPIC: resolveStringEnvVar(
        'VITE_USER_ASSISTANCE_TOPIC',
        process.env.VITE_USER_ASSISTANCE_TOPIC ?? '',
        ''
    ),
    VITE_USER_ASSISTANCE_SCOPE: resolveStringEnvVar(
        'VITE_USER_ASSISTANCE_SCOPE',
        process.env.VITE_USER_ASSISTANCE_SCOPE ?? '',
        ''
    ),
    VITE_USER_ASSISTANCE_DOC_VERSION: resolveStringEnvVar(
        'VITE_USER_ASSISTANCE_DOC_VERSION',
        process.env.VITE_USER_ASSISTANCE_DOC_VERSION ?? '',
        ''
    ),
    VITE_USER_ASSISTANCE_AVAILABLE: resolveBooleanEnvVar(
        'VITE_USER_ASSISTANCE_AVAILABLE',
        process.env.VITE_USER_ASSISTANCE_AVAILABLE ?? 'false',
        false
    ),
    VITE_ADOBE_ANALYTICS_URL: resolveStringEnvVar(
        'VITE_ADOBE_ANALYTICS_URL',
        process.env.VITE_ADOBE_ANALYTICS_URL ?? '',
        ''
    ),
};
const buildTimeEnv = {
    APP_VERSION: resolveStringEnvVar('APP_VERSION', process.env.APP_VERSION ?? '', '1.5.0'),
};

if (!runtimeEnv.VITE_REST_API_HOST) {
    throw new Error('VITE_REST_API_HOST is not defined in environment variables');
}
export const env = {
    ...runtimeEnv,
    ...buildTimeEnv,
} as const;
